module.exports = __webpack_public_path__ + "img/Baldwin-t-24533-011-474x313.fbfc9133.jpg";